"use strict";require("next/dist/build/polyfills/polyfill-nomodule");